import { Coupon } from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import cms from './cms';

interface getCouponByCouponNameAndCompanyIdProps {
  couponCode: string;
  companyId: number;
}

export async function getCouponByCouponNameAndCompanyId({
  couponCode,
  companyId,
}: getCouponByCouponNameAndCompanyIdProps): Promise<Coupon | null> {
  try {
    const response = await cms.get(
      `/v2/coupon/price/${couponCode}/${companyId}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to get coupon 🚨');
  }
}
